// /* デザインを揃える */
const I18N = {
  isEnglish() {
    const locale = window.themeLocale || document.documentElement.lang || 'ja';
    return locale.toLowerCase() === 'en';
  },
  t(ja, en) {
    return I18N.isEnglish() ? en : ja;
  },
  localePrefix() {
    return I18N.isEnglish() ? '/en' : '';
  },
};


function getMarketCountry() {
  return (window.Shopify && window.Shopify.country) || 'JP';
}
function getMarketLanguage() {
  const locale = window.themeLocale || (window.Shopify && window.Shopify.locale) || 'ja';
  return locale.toUpperCase();
}
function shouldShowTaxIncluded() {
  return window.themeShowTaxIncluded !== false;
}

// ============================================================
// SwappableItems：着せ替え可能アイテムの取得・描画
// ============================================================
class SwappableItems {
  static CASETYPE_FALLBACK_MAP = {
    h1_HY: I18N.t('Hybrid Case', 'Hybrid Case'),
    h1_SP: I18N.t('スリムプロテクションケース', 'Slim Protection Case'),
    h1_FL: I18N.t('Folio Case', 'Folio Case'),
    h1_HYSL: I18N.t('Hybrid Case with Sling', 'Hybrid Case with Sling'),
    h1_FLSL: I18N.t('Folio Case with Sling', 'Folio Case with Sling'),
    h1_SPLR: I18N.t('リボン付きケース', 'Case with Ribbon'),
  };

  static BLACK_COLOR_TAGS = [
    'm_BB',
    'm_GB',
    'm_MK',
    'm_PB',
    'm_PK',
    'cscl_半透明ブラックフレームwithブラックリング',
    'cscl_半透明フレームwithブラックリング',
  ];

  static WHITE_COLOR_TAGS = [
    'm_TW',
    'm_GW',
    'm_MS',
    'm_PW',
    'm_PS',
    'cscl_半透明ブラックフレームwithホワイトリング',
    'cscl_半透明フレームwithホワイトリング',
  ];
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.js-swappable-items-track');
    this.tags = (container.dataset.swapTags || '').split('+').filter(Boolean);
    this.currentHandle = container.dataset.currentHandle;
    this.currentTags = (container.dataset.currentTags || '').split(',').map((t) => t.trim()).filter(Boolean); // ★ この行を追加
    // CASEPLAY-253：カラー連携の対象 h1_ タグ（テーマ設定 color_property_target_h1）
    this.colorTargetH1 = (container.dataset.colorTargetH1 || '').split(/[\s,]+/).filter(Boolean);
    this.init();
  }

  // CASEPLAY-253：クイック追加用に properties[カラー] の値を組み立てる。
  // 正規化ルールは snippets/product-color-property.liquid と同一に保つこと
  // （cscl_ 除去 → 前後空白除去 → 全角スペース除去）
  _getColorPropertyValue(product) {
    const tags = (product && product.tags) || [];
    const isTarget = this.colorTargetH1.some((h1) => tags.indexOf(h1) !== -1);
    if (!isTarget) return '';
    const csclTag = tags.find((t) => t.indexOf('cscl_') === 0);
    if (!csclTag) return '';
    return csclTag.replace('cscl_', '').trim().replace(/　/g, '');
  }

  _getColorKey(tags) {
    const list = tags || [];
    if (list.some((t) => SwappableItems.BLACK_COLOR_TAGS.indexOf(t) !== -1)) return 'black';
    if (list.some((t) => SwappableItems.WHITE_COLOR_TAGS.indexOf(t) !== -1)) return 'white';
    return '';
  }

  init() {
    if (this.tags.length === 0) {
      console.warn('[SwappableItems] タグが取得できませんでした');
      this.container.style.display = 'none';
      return;
    }

    const query = this._buildQuery();
    console.log('[SwappableItems] query=', query); 
    this._fetchProducts(query).then((data) => this._onResult(data));
  }
  _fetchProducts(query) {
    const token = typeof theme_accessToken !== 'undefined' ? theme_accessToken : '';
    if (!token) {
      console.error('[SwappableItems] theme_accessToken が見つかりません');
      return Promise.resolve({ products: { edges: [] } });
    }

    const country = getMarketCountry();
    const language = getMarketLanguage();

    const body =
      'query @inContext(country: ' + country + ', language: ' + language + ') { products(query: "' +
      query +
      '", first: 24) {' +
      ' edges { cursor, node { ' +
      ' title, id, handle, tags,' +
      ' priceRange { minVariantPrice { amount, currencyCode } },' +
      ' variants(first: 100) { edges { node { id, availableForSale } } },' +
      ' images(first:1) { edges { node { originalSrc } } }' +
      ' } } } }';

    return fetch('/api/2024-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: body,
    })
      .then((res) => res.json())
      .then((json) => json.data || { products: { edges: [] } })
      .catch((err) => {
        console.error('[SwappableItems] fetch失敗', err);
        return { products: { edges: [] } };
      });
  }
  _onResult(data) {
    const edges = (data && data.products && data.products.edges) || [];
    let items = edges.map((edge) => edge.node).filter((product) => product.handle !== this.currentHandle);

    const CSCL_TARGET_H1_TAGS = ['h1_FM', 'h1_FP', 'h1_FS'];
    const isCsclTarget = CSCL_TARGET_H1_TAGS.some((tag) => this.currentTags.indexOf(tag) !== -1);

    if (isCsclTarget) {
      const myColorKey = this._getColorKey(this.currentTags); 

      let matched = [];

      if (myColorKey) {
        matched = items.filter((product) => this._getColorKey(product.tags) === myColorKey);
      }

      if (matched.length > 0) {
        items = matched;
      }
    }

    if (items.length === 0) {
      this.container.style.display = 'none';
      return;
    }

    this._getTagLabels(items).then((tagLabels) => {
      this._renderCards(items, tagLabels);
      this.container.style.display = '';
      this._initSlick();
    });
  }

  _getTagLabels(items) {
    const tags = [];
    items.forEach((product) => {
      ['productname_', 'col_'].forEach((prefix) => {
        const tag = this._findTagByPrefix(product.tags || [], prefix);
        if (tag && tags.indexOf(tag) === -1) tags.push(tag);
      });
    });
    return window.caseplayTagLabels.get(tags);
  }

  _buildQuery() {
    return this._buildTagQuery(this.tags); 
  }
  _buildTagQuery(tags) {
    return tags.map((t) => 'tag:\\"' + this._escapeQueryValue(t) + '\\"').join(' AND ');
  }

  _escapeQueryValue(value) {
    return String(value).replace(/"/g, '\\"');
  }

  _findTagByPrefix(tags, prefix) {
    return (tags || []).find((t) => t.indexOf(prefix) === 0) || '';
  }

  _resolveDisplayFields(product, tagLabels) {
    const tags = product.tags || [];
    const caseTag = this._findTagByPrefix(tags, 'h1_');
    const productNameTag = this._findTagByPrefix(tags, 'productname_');
    const colTag = this._findTagByPrefix(tags, 'col_');

    const caseTypeName =
      (window.templateProductI18n && window.templateProductI18n.caseTypes && window.templateProductI18n.caseTypes[caseTag]) || // ★ 追加: 最優先
      (window.caseplayItemTypeTranslations &&
        window.caseplayItemTypeTranslations.en &&
        window.caseplayItemTypeTranslations.en[caseTag]) ||
      (window.fox && window.fox.settings && window.fox.settings.h1 ? window.fox.settings.h1[caseTag] : '') ||
      SwappableItems.CASETYPE_FALLBACK_MAP[caseTag] ||
      '';

    const displayTitle = productNameTag ? tagLabels[productNameTag] || '' : '';
    const displayTitleFallback = productNameTag ? productNameTag.replace('productname_', '') : product.title;

    const genreLabel = colTag ? tagLabels[colTag] || '' : '';

    return { caseTypeName, displayTitle, displayTitleFallback, genreLabel };
  }

  _extractBracketParts(title) {
    if (!title) return { tag: '', text: '' };

    const openIdx = title.indexOf('［');
    const closeIdx = title.lastIndexOf('］');
    if (openIdx === -1 || closeIdx === -1 || closeIdx <= openIdx) {
      return { tag: '', text: title };
    }

    const bracketContent = title.slice(openIdx + 1, closeIdx).trim();
    const sepIdx = bracketContent.indexOf(' - ');

    if (sepIdx === -1) {
      return { tag: '', text: bracketContent };
    }

    return {
      tag: bracketContent.slice(0, sepIdx).trim(),
      text: bracketContent.slice(sepIdx + 3).trim(),
    };
  }

  _renderCards(items, tagLabels) {
    this.productsByVariantId = this.productsByVariantId || {};

    this.track.innerHTML = items
      .map((product) => {
        const fields = this._resolveDisplayFields(product, tagLabels || {});
        const bracketParts = this._extractBracketParts(product.title);
        const displayTag = fields.genreLabel || bracketParts.tag;
        const displayText = fields.displayTitle || bracketParts.text || fields.displayTitleFallback;

        const priceAmount =
          product.priceRange && product.priceRange.minVariantPrice
            ? product.priceRange.minVariantPrice.amount
            : null;
        const currencyCode =
          product.priceRange &&
          product.priceRange.minVariantPrice &&
          product.priceRange.minVariantPrice.currencyCode
            ? product.priceRange.minVariantPrice.currencyCode
            : 'JPY';
        const priceText = priceAmount
          ? new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-US' : 'ja-JP', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: currencyCode === 'JPY' ? 0 : 2,
            }).format(Number(priceAmount)) + (shouldShowTaxIncluded() ? I18N.t('（税込）', ' (tax included)') : '') // ★ 変更
          : '';
        const imageEdge = product.images && product.images.edges && product.images.edges[0];
        const imageUrl = imageEdge ? imageEdge.node.originalSrc : '';
        const url = I18N.localePrefix() + '/products/' + product.handle;
        const variantEdges = (product.variants && product.variants.edges) || [];
        const availableEdge = variantEdges.find((e) => e.node.availableForSale);
        const variantEdge = availableEdge || variantEdges[0];
        const variantId = variantEdge ? variantEdge.node.id.split('/').pop() : '';
        const isSoldOut = variantEdges.length > 0 && !availableEdge;
        const colorProperty = this._getColorPropertyValue(product); // CASEPLAY-253


        return `
      <div class="swappable-items__card">
        <a href="${url}" class="design-match-card-link">
          <figure class="swappable-items__card-img">
            ${imageUrl ? `<img src="${imageUrl}" alt="${this._escapeHtml(fields.displayTitle)}" loading="lazy">` : ''}
          </figure>
          <p class="swappable-items__badge">${this._escapeHtml(fields.caseTypeName)}</p>
          <div class="swappable-items__name">
            ${displayTag ? `<p class="swappable-items__col-tag">${this._escapeHtml(displayTag)}</p>` : ''}
            <p class="swappable-items__col-title">${this._escapeHtml(displayText)}</p>
          </div>
        </a>
        <p class="swappable-items__price">${priceText}</p>
        <button
          type="button"
          class="swappable-items__cart-btn"
          data-variant-id="${variantId}"
          data-color-property="${this._escapeHtml(colorProperty)}"
          ${isSoldOut ? 'disabled' : ''}
        >${isSoldOut ? I18N.t('売り切れ', 'Sold Out') : I18N.t('カートに入れる ›', 'Add to Cart ›')}</button>
      </div>
    `;
      })
      .join('');

    this._bindCartButtons();
  }

  _bindCartButtons() {
    this.track.querySelectorAll('.swappable-items__cart-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        btn.disabled = true;
        const originalText = btn.textContent;
        btn.textContent = I18N.t('追加中...', 'Adding...');

        // CASEPLAY-253：対象商品は properties[カラー] を付与
        const payload = { id: variantId, quantity: 1 };
        if (btn.dataset.colorProperty) payload.properties = { カラー: btn.dataset.colorProperty };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then((res) => {
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(() => this._updateCartCount())
          .then(() => {
            btn.textContent = I18N.t('追加しました', 'Added');
            document.dispatchEvent(new CustomEvent('cart:updated'));


            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          })
          .catch((err) => {
            console.error('[SwappableItems] カート追加失敗', err);
            btn.textContent = I18N.t('追加に失敗しました', 'Failed to add');
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1500);
          });
      });
    });
  }

  _updateCartCount() {
    return fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch((err) => {
        console.error('[SwappableItems] カート個数の取得失敗', err);
      });
  }

  _escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  _initSlick() {
    const $track = $(this.track);
    if ($track.hasClass('slick-initialized')) return;
    $track.slick({
      infinite: false,
      slidesToShow: 3.9,
      slidesToScroll: 1,
      arrows: false,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      touchThreshold: 10,
      responsive: [
        { breakpoint: 1060, settings: { slidesToShow: 2.2 } },
        { breakpoint: 480, settings: { slidesToShow: 1.2 } },
      ],
    });
    this.container
      .querySelector('.swappable-items__prev')
      ?.addEventListener('click', () => $track.slick('slickPrev'));
    this.container
      .querySelector('.swappable-items__next')
      ?.addEventListener('click', () => $track.slick('slickNext'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-swappable-items').forEach((el) => new SwappableItems(el));
});

// ============================================================
// DesignMatchItems：デザインを揃える商品の取得・描画
// ============================================================
class DesignMatchItems {
  static PRIORITY_CATEGORIES = [
    { key: 'phoneCase', label: 'スマホケース', match: (tags) => tags.includes('h1_SP') },
    { key: 'earphoneCase', label: 'イヤホンケース', match: (tags) => tags.includes('h1_WE') },
    { key: 'watchBand', label: 'ウォッチバンド', match: (tags) => tags.includes('h1_SL') },
    {
      key: 'premiumRingStand',
      label: 'プレミアムリングスタンド',
      match: (tags) => tags.some((t) => t.toLowerCase() === 'h1_ps'),
    },
  ];
  static EXCLUDE_FROM_OTHERS_H1_LIST = [
    'h1_HY',
    'h1_FL',
    'h1_FS',
    'h1_FP',
    'h1_MS',
    'h1_PN',
    'h1_PP',
    'h1_PM',
    'h1_FM',
    'h1_FC',
    'h1_FN',
    'h1_BC',
    'h1_FR',
  ];

  static CASETYPE_FALLBACK_MAP = {
    h1_HY: 'Hybrid Case',
    h1_SP: I18N.t('スリムプロテクションケース', 'Slim Protection Case'), 
    h1_FL: 'Folio Case',
    h1_FR: I18N.t('スリムプロテクションプレミアムケース', 'Slim Protection Premium Case'), 
  };
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.js-design-match-track');
    this.h2Tag = container.dataset.h2Tag;
    this.moTag = container.dataset.moTag;
    this.currentHandle = container.dataset.currentHandle;
    // CASEPLAY-272：機種別に非表示にするアイテム識別子（商品タグ・小文字）。Liquid側でテーマ設定から解析済み
    this.hideItems = (container.dataset.hideItems || '')
      .split(',')
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
    this.init();
  }

  // CASEPLAY-272：識別子（商品タグ）が非表示対象か
  _isTagHidden(tag) {
    return this.hideItems.indexOf(String(tag || '').toLowerCase()) > -1;
  }

  // CASEPLAY-272：商品のいずれかのタグが非表示対象に含まれるか
  _isProductHidden(product) {
    if (!this.hideItems.length) return false;
    return (product.tags || []).some((t) => this._isTagHidden(t));
  }

  // CASEPLAY-272：非表示対象のカテゴリは問い合わせ自体を省略する
  _fetchQueryUnlessHidden(identifierTag, query) {
    if (this._isTagHidden(identifierTag)) return Promise.resolve({ products: { edges: [] } });
    return this._fetchQuery(query);
  }

  init() {
    if (!this.h2Tag) {
      console.warn('[DesignMatchItems] h2タグが取得できませんでした');
      this.container.style.display = 'none';
      return;
    }

    const designQuery = 'tag:\\"' + this.h2Tag + '\\"';
    const shoulderQuery = 'tag:\\"shouldertag\\"';

    const earphoneQuery = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_WE\\"';
    const watchBandQuery = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_SL\\"';
    const ringStandQuery = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_ps\\"';
    // 追加
    const cwQuery = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_CW\\"';
    const pwQuery = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_PW\\"';

    const phoneCaseQueryWithMo = this.moTag
      ? 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"' + this.moTag + '\\" AND tag:\\"h1_SP\\"'
      : null;
    const phoneCaseQueryFallback = 'tag:\\"' + this.h2Tag + '\\" AND tag:\\"h1_SP\\"';

    // ★追加: mo_込みで0件なら h2_ のみで再検索し、必ず候補が拾えるようにする
    const phoneCasePromise = (phoneCaseQueryWithMo
      ? this._fetchQuery(phoneCaseQueryWithMo)
      : Promise.resolve({ products: { edges: [] } })
    ).then((data) => {
      const hasResult = data && data.products && data.products.edges && data.products.edges.length > 0;
      if (hasResult) return data;
      return this._fetchQuery(phoneCaseQueryFallback);
    });

    // CASEPLAY-272：非表示対象のカテゴリはクエリを省略（スマホケースは描画前フィルタで除外）
    //   識別子は各クエリが条件にしているタグ（h1_WE / h1_SL 等）。商品単位の除外は _isProductHidden で行う
    Promise.all([
      this._fetchQuery(designQuery),
      this._fetchQueryUnlessHidden('shouldertag', shoulderQuery),
      this._fetchQueryUnlessHidden('h1_WE', earphoneQuery),
      this._fetchQueryUnlessHidden('h1_SL', watchBandQuery),
      this._fetchQueryUnlessHidden('h1_ps', ringStandQuery),
      phoneCasePromise, // ★変更
      this._fetchQueryUnlessHidden('h1_CW', cwQuery),
      this._fetchQueryUnlessHidden('h1_PW', pwQuery),
    ]).then(([designData, shoulderData, earphoneData, watchBandData, ringStandData, phoneCaseData, cwData, pwData]) => {
      this._onResult(designData, shoulderData, {
        phoneCase: phoneCaseData,
        earphoneCase: earphoneData,
        watchBand: watchBandData,
        premiumRingStand: ringStandData,
      }, [cwData, pwData]);
    });
  }

  _fetchQuery(query) {
    return this._fetchAllPages(query);
  }

  _fetchAllPages(query, cursor, accumulatedEdges) {
    accumulatedEdges = accumulatedEdges || [];
    return this._fetchPage(query, cursor).then((data) => {
      const edges = (data && data.products && data.products.edges) || [];
      const pageInfo = (data && data.products && data.products.pageInfo) || {};
      const combined = accumulatedEdges.concat(edges);

      if (pageInfo.hasNextPage && pageInfo.endCursor) {
        return this._fetchAllPages(query, pageInfo.endCursor, combined);
      }

      return { products: { edges: combined } };
    });
  }

  _fetchPage(query, cursor) {
    const token = typeof theme_accessToken !== 'undefined' ? theme_accessToken : '';
    if (!token) {
      console.error('[DesignMatchItems] theme_accessToken が見つかりません');
      return Promise.resolve({ products: { edges: [] } });
    }

    const country = getMarketCountry();
    const language = getMarketLanguage();
    const afterClause = cursor ? ', after: \\"' + cursor + '\\"' : ''; 

    const body =
      'query @inContext(country: ' + country + ', language: ' + language + ') { products(query: "' +
      query +
      '", first: 24' + afterClause + ') {' + 
      ' pageInfo { hasNextPage, endCursor },' +
      ' edges { cursor, node { ' +
      ' title, id, handle, tags,' +
      ' priceRange { minVariantPrice { amount, currencyCode } },' +
      ' variants(first: 1) { edges { node { id } } },' +
      ' images(first:1) { edges { node { originalSrc } } }' +
      ' } } } }';

    return fetch('/api/2024-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: body,
    })
      .then((res) => res.json())
      .then((json) => json.data || { products: { edges: [] } })
      .catch((err) => {
        console.error('[DesignMatchItems] fetch失敗', err);
        return { products: { edges: [] } };
      });
  }

  _getIndexNumber(tags) {
    const indexTag = this._findTagByPrefix(tags, 'index_');
    if (!indexTag) return Infinity; // index_が無い商品は最後に回す
    const num = parseInt(indexTag.replace('index_', ''), 10);
    return Number.isNaN(num) ? Infinity : num;
  }

  _onResult(designData, shoulderData, priorityData, afterShoulderData) {
    // CASEPLAY-272：全カテゴリ共通で非表示ルールに該当する商品を描画前に除外（「その他」枠への混入も防ぐ）
    const designItems = ((designData.products && designData.products.edges) || [])
      .map((e) => e.node)
      .filter((p) => p.handle !== this.currentHandle)
      .filter((p) => !this._isProductHidden(p));

    const shoulderItems = ((shoulderData.products && shoulderData.products.edges) || [])
      .map((e) => e.node)
      .filter((p) => p.handle !== this.currentHandle)
      .filter((p) => !this._isProductHidden(p));

    const usedH1 = new Set();
    const cards = [];

    const priorityKeyMap = {
      phoneCase: I18N.t('スマホケース', 'Phone Case'),
      earphoneCase: I18N.t('イヤホンケース', 'Earphone Case'),
      watchBand: I18N.t('ウォッチバンド', 'Watch Band'),
      premiumRingStand: I18N.t('プレミアムリングスタンド', 'Premium Ring Stand'),
    };

    // ★変更: phoneCaseを先に単独処理し、確実にcardsの先頭へ
    const phoneCaseItems = ((priorityData.phoneCase.products && priorityData.phoneCase.products.edges) || [])
      .map((e) => e.node)
      .filter((p) => p.handle !== this.currentHandle)
      .filter((p) => !this._isProductHidden(p)); // CASEPLAY-272

    if (phoneCaseItems.length) {
      const sorted = phoneCaseItems.slice().sort((a, b) => this._getIndexNumber(a.tags) - this._getIndexNumber(b.tags));
      const chosen = sorted[0];
      cards.unshift({ product: chosen, label: priorityKeyMap.phoneCase }); // ★ unshiftで先頭固定
      const h1 = this._findTagByPrefix(chosen.tags, 'h1_');
      if (h1) usedH1.add(h1);
    } else {
      console.warn('[DesignMatchItems] 該当商品なし:', priorityKeyMap.phoneCase);
    }

    ['earphoneCase', 'watchBand', 'premiumRingStand'].forEach((key) => {
      const data = priorityData[key];
      const items = ((data.products && data.products.edges) || [])
        .map((e) => e.node)
        .filter((p) => p.handle !== this.currentHandle)
        .filter((p) => !this._isProductHidden(p)); // CASEPLAY-272

      if (items.length) {
        const sorted = items.slice().sort((a, b) => this._getIndexNumber(a.tags) - this._getIndexNumber(b.tags));
        const chosen = sorted[0];
        cards.push({ product: chosen, label: priorityKeyMap[key] });
        const h1 = this._findTagByPrefix(chosen.tags, 'h1_');
        if (h1) usedH1.add(h1);
      } else {
        console.warn('[DesignMatchItems] 該当商品なし:', priorityKeyMap[key]);
      }
    });

    if (shoulderItems.length) {
      const sortedShoulder = shoulderItems
        .slice()
        .sort((a, b) => this._getIndexNumber(a.tags) - this._getIndexNumber(b.tags));
      const chosenShoulder = sortedShoulder[0];
      cards.push({ product: chosenShoulder, label: I18N.t('スマホショルダー', 'Phone Shoulder Strap') });
      const shoulderH1 = this._findTagByPrefix(chosenShoulder.tags, 'h1_');
      if (shoulderH1) usedH1.add(shoulderH1);
    }

    (afterShoulderData || []).forEach((data) => {
      const items = ((data && data.products && data.products.edges) || [])
        .map((e) => e.node)
        .filter((p) => p.handle !== this.currentHandle)
        .filter((p) => !this._isProductHidden(p)); // CASEPLAY-272
      if (!items.length) return;

      const chosen = items
        .slice()
        .sort((a, b) => this._getIndexNumber(a.tags) - this._getIndexNumber(b.tags))[0];
      const h1 = this._findTagByPrefix(chosen.tags, 'h1_');

      cards.push({ product: chosen, label: this._getH1Label(h1) || h1 }); // ラベルが無ければタグ名を表示
      if (h1) usedH1.add(h1);
    });

    const othersMap = {};
    designItems.forEach((p) => {
      const h1 = this._findTagByPrefix(p.tags, 'h1_');
      if (!h1) return;
      if (usedH1.has(h1)) return;
      if (DesignMatchItems.EXCLUDE_FROM_OTHERS_H1_LIST.indexOf(h1) > -1) return;

      const currentIndexNum = this._getIndexNumber(p.tags);
      const existing = othersMap[h1];
      if (!existing || currentIndexNum < this._getIndexNumber(existing.tags)) {
        othersMap[h1] = p;
      }
    });
    const othersArr = this._shuffle(Object.values(othersMap));
    othersArr.forEach((p) => {
      const h1 = this._findTagByPrefix(p.tags, 'h1_');
      cards.push({ product: p, label: this._getH1Label(h1) });
    });

    if (!cards.length) {
      this.container.style.display = 'none';
      return;
    }

    this._getTagLabels(cards.map((card) => card.product)).then((tagLabels) => {
      this._renderCards(cards, tagLabels);
      this.container.style.display = '';
      this._initSlick();
    });
  }

  _getTagLabels(items) {
    const tags = [];
    items.forEach((product) => {
      ['productname_', 'col_'].forEach((prefix) => {
        const tag = this._findTagByPrefix(product.tags || [], prefix);
        if (tag && tags.indexOf(tag) === -1) tags.push(tag);
      });
    });
    return window.caseplayTagLabels.get(tags);
  }

  _shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  _findTagByPrefix(tags, prefix) {
    return (tags || []).find((t) => t.indexOf(prefix) === 0) || '';
  }

  _getH1Label(h1) {
    return (
      (window.templateProductI18n && window.templateProductI18n.caseTypes && window.templateProductI18n.caseTypes[h1]) ||
      (window.fox && window.fox.settings && window.fox.settings.h1 && window.fox.settings.h1[h1]) ||
      DesignMatchItems.CASETYPE_FALLBACK_MAP[h1] ||
      ''
    );
  }
  _extractBracketParts(title) {
    if (!title) return { tag: '', text: '' };

    const openIdx = title.indexOf('［');
    const closeIdx = title.lastIndexOf('］');
    if (openIdx === -1 || closeIdx === -1 || closeIdx <= openIdx) {
      return { tag: '', text: title };
    }

    const bracketContent = title.slice(openIdx + 1, closeIdx).trim();
    const sepIdx = bracketContent.indexOf(' - ');

    if (sepIdx === -1) {
      return { tag: '', text: bracketContent };
    }

    return {
      tag: bracketContent.slice(0, sepIdx).trim(),
      text: bracketContent.slice(sepIdx + 3).trim(),
    };
  }

  _renderCards(cards, tagLabels) {
    this.track.innerHTML = cards
      .map(({ product, label }) => {
        const tags = product.tags || [];
        const h1 = this._findTagByPrefix(tags, 'h1_');
        const colTag = this._findTagByPrefix(tags, 'col_');
        const productNameTag = this._findTagByPrefix(tags, 'productname_');

        const priceAmount =
          product.priceRange && product.priceRange.minVariantPrice
            ? product.priceRange.minVariantPrice.amount
            : null;
        const currencyCode =
          product.priceRange &&
          product.priceRange.minVariantPrice &&
          product.priceRange.minVariantPrice.currencyCode
            ? product.priceRange.minVariantPrice.currencyCode
            : 'JPY';
        const priceText = priceAmount
          ? new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-US' : 'ja-JP', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: currencyCode === 'JPY' ? 0 : 2,
            }).format(Number(priceAmount)) + (shouldShowTaxIncluded() ? I18N.t('（税込）', ' (tax included)') : '') // ★ 変更
          : '';

        const imageEdge = product.images && product.images.edges && product.images.edges[0];
        const imageUrl = imageEdge ? imageEdge.node.originalSrc : '';
        const detailUrl = I18N.localePrefix() + '/products/' + product.handle;

        let othersUrl = I18N.localePrefix() + '/collections/all';
        const otherTagParams = [];
        if (h1) otherTagParams.push('tag=' + encodeURIComponent(h1));
        if (colTag) otherTagParams.push('tag=' + encodeURIComponent(colTag));
        if (otherTagParams.length) othersUrl += '?' + otherTagParams.join('&');

        let displayTag = '';
        let displayText = '';
        if (label === I18N.t('スマホショルダー', 'Phone Shoulder Strap')) { 
          displayTag = I18N.t('for アクセサリー', 'for Accessories');
          displayText = productNameTag ? (tagLabels && tagLabels[productNameTag]) || productNameTag.replace('productname_', '') : product.title;
        } else {
          const bracketParts = this._extractBracketParts(product.title);
          displayTag = (tagLabels && tagLabels[colTag]) || bracketParts.tag;
          displayText = (tagLabels && tagLabels[productNameTag]) || bracketParts.text || product.title;
        }

        return `
        <div class="design-match-card">
          <figure class="design-match-card-img">
            ${imageUrl ? `<img src="${imageUrl}" alt="${this._escapeHtml(label)}" loading="lazy">` : ''}
          </figure>
          <p class="design-match-card__badge">${this._escapeHtml(label)}</p>
          <div class="design-match-card__name">
            ${displayTag ? `<p class="design-match-card__col-tag">${this._escapeHtml(displayTag)}</p>` : ''}
            <p class="design-match-card__col-title">${this._escapeHtml(displayText)}</p>
          </div>
          <p class="design-match-card__price">${priceText}</p>
          <a class="design-match-card__btn design-match-card__btn--detail" href="${detailUrl}">${I18N.t('詳しく見る ›', 'View Details ›')}</a>
          <a class="design-match-card__btn design-match-card__btn--others" href="${othersUrl}">${I18N.t('他のデザインを見る ›', 'View Other Designs ›')}</a>
        </div>
      `;
      })
      .join('');
  }

  _escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  _initSlick() {
    const $track = $(this.track);
    if ($track.hasClass('slick-initialized')) return;
    $track.slick({
      infinite: false,
      slidesToShow: 3.9,
      slidesToScroll: 1,
      arrows: false,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      touchThreshold: 10,
      responsive: [
        { breakpoint: 1060, settings: { slidesToShow: 2.2 } },
        { breakpoint: 480, settings: { slidesToShow: 1.2 } },
      ],
    });
    this.container.querySelector('.design-match__prev')?.addEventListener('click', () => $track.slick('slickPrev'));
    this.container.querySelector('.design-match__next')?.addEventListener('click', () => $track.slick('slickNext'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-design-match').forEach((el) => new DesignMatchItems(el));
});
